import Mottos from './Mottos';
export default Mottos;